export type UserSettings = {
  workDuration: number;  // Minutes
  breakDuration: number; // Minutes
  soundNotification: boolean;
  webNotification: boolean;
  autoCompleteTask: boolean;
};

export type PomodoroMode = 'work' | 'break';

export type PomodoroState = {
  isActive: boolean;
  isPaused: boolean;
  mode: PomodoroMode;
  timeLeft: number;
  workDuration: number;
  breakDuration: number;
  completedPomodoros: number;
  currentTaskId: number | null;
  startTime: Date | null;
  pauseTime: Date | null;
  currentPomodoroId: string | null;
  lastSavedTime?: number;
  soundNotification: boolean;
  webNotification: boolean;
  accumulatedTime: number;
};

export type PomodoroContextType = {
  state: PomodoroState;
  startTimer: () => void;
  pauseTimer: () => void;
  resetTimer: () => void;
  skipToBreak: () => void;
  skipToWork: () => void;
  completePomodoro: () => void;
  setWorkDuration: (minutes: number) => void;
  setBreakDuration: (minutes: number) => void;
  setCurrentTaskId: (taskId: number | null) => void;
  toggleWebNotification: () => void;
};

export const DEFAULT_POMODORO_STATE: PomodoroState = {
  isActive: false,
  isPaused: false,
  mode: 'work',
  timeLeft: 25 * 60,
  workDuration: 25 * 60,
  breakDuration: 5 * 60,
  completedPomodoros: 0,
  currentTaskId: null,
  startTime: null,
  pauseTime: null,
  currentPomodoroId: null,
  soundNotification: true,
  webNotification: true,
  accumulatedTime: 0,
  lastSavedTime: Date.now(),
}; 